import API from "@/api/API";

/**
 * Product add-ons the company's subscription grants (exportCapabilitiesEnabled,
 * exportThreeDModelEnabled, aiInspectionEnabled, airteamDesignerEnabled, ...).
 *
 * They restrict customers only — employees work across companies and always see
 * the full toolset. Anything we could not resolve stays permitted: a failed or
 * skipped fetch (anonymous share links, a company with no v2 subscription) must
 * never silently strip a feature the user had yesterday.
 */
const state = {
  addons: {},
  loaded: false,
};

const getters = {
  subscriptionAddonsLoaded: (state) => state.loaded,
  addonEnabled: (state, getters) => (key) => {
    if (getters.activeUserIsEmployee) return true;
    return state.addons[key] !== false;
  },
};

const mutations = {
  setSubscriptionAddons(state, addons) {
    state.addons = addons || {};
    state.loaded = true;
  },
};

const actions = {
  // Never rejects: the viewer must still load when the subscription does not.
  async fetchSubscriptionAddons({ commit }, companyId) {
    if (!companyId) return;
    try {
      const { data } = await API.subscriptions.getCompanyAddons(companyId);
      commit("setSubscriptionAddons", data || {});
    } catch (err) {
      console.error(
        `Subscription add-ons unresolved for company ${companyId}; all add-ons permitted.`,
        err
      );
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
